<script>
  export let sources;
  export let width_percent;
  export let youtube_id;
  export let width = undefined;
  export let height = undefined;
  export let yt_width = 816;
  export let yt_height = 480;
  export let autoplay = false;

  $: autoplay_num = autoplay ? 1 : 0;

  let style =
    "--width: " + (width_percent ? width_percent + "%" : "100%") + ";";
  style += "--yt-width:" + (yt_width ?? 816) + "px;";
  style += "--yt-height:" + (yt_height ?? 480) + "px;";
</script>

<div class="locked-video-container">
  <!-- svelte-ignore a11y-media-has-caption -->
  {#if youtube_id}
    <iframe
      {style}
      width={yt_width}
      height={yt_height}
      src="https://www.youtube.com/embed/{youtube_id}?autoplay={autoplay_num}"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      class="youtube-embed"
    />
  {:else if sources}
    <video class="locked-video" {style} controls {width} {height}>
      {#each Object.entries(sources) as [type, src]}
        <source {type} {src} />
      {/each}
    </video>
  {/if}
</div>

<style>
  .locked-video-container {
    width: 100%;
  }

  .locked-video {
    width: var(--width);
  }

  .youtube-embed {
    max-width: var(--yt-width);
    width: var(--width);
    height: var(--yt-height);
  }
</style>
